; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.account = {
        name: 'account',

        version: '1.0.0',

        settings: {
            callback: function () { }
        },

        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, '');
            var self = this;

            // à conserver
            this.bindings(method, options);
        },
        initFormulaire: function () {
            $.validator.addMethod(
                    "regex",
                    function (value, element, regexp) {
                        var re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    "Please check your input."
            );
            $('#form-identification-login-password').validate(
                {
                    errorContainer: $("#form-identification-login-password span.error"),
                }
            );
            $('#form-identification-numero-nom').validate(
                {
                    errorContainer: $("#form-identification-identification-password span.error"),
                }
            );
            $('#form-creation-compte').validate(
                {
                    errorContainer: $("#span-error-resume"),
                }
            );
            $('#form-modification-compte').validate(
                {
                    errorContainer: $("#span-error-resume"),
                }
            );
            $('#form-mot-de-passe-oublie').validate({
                rules: {
                    email: {
                        required: true,
                        regex: "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}"
                    },
                }
            });


        },
        initPopin: function () {

        },
        initToolTip: function () {
            $('.hasTooltip').each(function () {
                $(this).qtip({
                    content: {
                        text: $(this).next('div') // Use the "div" element next to this for the content
                    },
                    show: {
                        delay: 200,
                        effect: function () {
                            $(this).show("slide", { direction: "down" }, "fast");
                        }
                    },
                    hide: {
                        fixed: true,
                        delay: 500,
                        effect: function () {
                            $(this).hide("slide", { direction: "down" }, "fast");
                        },
                    },
                    position: { my: 'bottom center', at: 'top center', adjust: { y: -28 } }

                });
            });
        },
        update: function (data) {
            $.ajaxSetup({ cache: false });
            $(data.elt).html(data.response);
            $(document).foundation('tab', 'init');
            $(document).foundation('reveal', 'init');
            $(document).foundation('alert', 'init');
            $(".has-mq-class").mqClass();
            $(document).foundation('account', 'initToolTip');
            $(document).foundation('account', 'initPopin');
            $(document).foundation('account', 'initFormulaire');
        },
        events: function () {
            var self = this;
            var S = this.S;
            $(this.scope)
            .ready(function (event) {
                $.ajaxSetup({ cache: false });
                $(document).foundation('tab', 'init');
                $(document).foundation('reveal', 'init');
                $(document).foundation('account', 'initToolTip');
                $(document).foundation('account', 'initPopin');
                $(document).foundation('account', 'initFormulaire');

            })
            .on('submit', '#form-mot-de-passe-oublie', function (event) {
                event.preventDefault();
                $('#form-mot-de-passe-oublie').validate(
                    {
                        errorContainer: $("#form-mot-de-passe-oublie span.error"),
                    }
                );
                if ($('#form-mot-de-passe-oublie').valid()) {
                    var email = $('#input-email').val();
                    var jqxhr = $.getJSON('/Account/RecupererIdentifiants', { email: email }, function (data) {
                        if (data.IsValid) {
                            $('#popin-informations #title').html('MOT DE PASSE OU IDENTIFIANT OUBLIÉ ?');
                            $('#popin-informations #infos').html('Un email contenant vos informations de connexion vient de vous être envoyé.');
                            $('#popin-informations').foundation('reveal', 'open');
                        }
                        else {
                            var html = '';
                            for (var i = 0; i < data.Erreurs.length; i++) {
                                html += data.Erreurs[i] + '<br>';
                            }

                            $('#erreur-globale .error-text').html(html);
                            $('#erreur-globale').foundation('reveal', 'open');
                        }
                    })
                }
            })
            .on('click', '#button-connecter-login-password', function (event) {
                event.preventDefault();
                if ($('#form-identification-login-password').valid()) {
                    var idClient = $('#input-id-client').val();
                    var paswword = $('#input-password-client').val();
                    var jqxhr = $.getJSON('/Account/IdentifierClientByLoginAndPassword', {
                        login: idClient, password: paswword
                    }, function (data) {
                        if (data.IsValid) {
                            var url = $('#button-connecter-login-password').attr('data-url');
                            if (url != null && url != "" && typeof (url) != "undefined")
                                window.location = url;
                            else
                                window.location = data.Redirection;
                        }
                        else {
                            var html = '';
                            for (var i = 0; i < data.Erreurs.length; i++) {
                                html += data.Erreurs[i] + '<br>';
                            }

                            $('#erreur-globale .error-text').html(html);
                            $('#erreur-globale').foundation('reveal', 'open');
                        }
                    })
                }
            })
            .on('click', '#button-connecter-numero-nom', function (event) {
                event.preventDefault();
                if ($('#form-identification-numero-nom').valid()) {
                    var idClient = $('#input-numero-client').val();
                    var nomClient = $('#input-nom-client').val();
                    var jqxhr = $.getJSON('/Account/IdentifierClientByNumberAndName', { numeroClient: idClient, nom: nomClient }, function (data) {
                        if (data.IsValid) {
                            var url = $('#button-connecter-numero-nom').attr('data-url');
                            if (url != null && url != "" && typeof (url) != "undefined")
                                window.location = url;
                            else
                                window.location = data.Redirection;
                        }
                        else {
                            var html = '';
                            for (var i = 0; i < data.Erreurs.length; i++) {
                                html += data.Erreurs[i] + '<br>';
                            }

                            $('#erreur-globale .error-text').html(html);
                            $('#erreur-globale').foundation('reveal', 'open');
                        }
                    })
                }
            })
            .on('toggled', '#tab-account', function (event, tab) {
                console.log(tab);
            })
            ;
        },

        reflow: function () { }
    };
}(jQuery, window, window.document));

